import { FAQItem } from '../types';

export const faqItems: FAQItem[] = [
  {
    id: 'how-it-works',
    question: 'How does this service work?',
    answer: "It's simple! Upload a 30-second video of yourself, personalize your Santa message, and we'll transform it into a magical AI-generated Santa video. Download and share it with your loved ones!",
    icon: '🎅'
  },
  {
    id: 'video-length',
    question: 'How long are the videos?',
    answer: 'Each video is 30 seconds long, perfect for personalized holiday greetings.',
    icon: '⏱️'
  },
  {
    id: 'customization',
    question: 'Can I customize the message in the video?',
    answer: 'Yes! You can include a name and a personal message that Santa will deliver in your video.',
    icon: '✨'
  },
  {
    id: 'delivery-time',
    question: 'How quickly will I receive my video?',
    answer: 'Videos are typically processed and ready for download within 24-48 hours. During peak holiday times, it may take slightly longer.',
    icon: '🎄'
  },
  {
    id: 'file-format',
    question: 'What file format will my video be in?',
    answer: 'Your video will be delivered in MP4 format, compatible with all major devices and platforms.',
    icon: '📹'
  },
  {
    id: 'refunds',
    question: 'Can I request a refund?',
    answer: "Due to the custom nature of our videos, we are unable to offer refunds. However, if there's an issue with your video, our support team will make it right!",
    icon: '💝'
  },
  {
    id: 'urgent-delivery',
    question: 'What if I need my video urgently?',
    answer: 'We offer a priority processing option for $20, which guarantees delivery within 12 hours.',
    icon: '⚡'
  },
  {
    id: 'multiple-videos',
    question: 'Can I order more than one video?',
    answer: 'Absolutely! Choose one of our packages to create multiple videos for family, friends, or colleagues.',
    icon: '🎁'
  },
  {
    id: 'data-security',
    question: 'Is my data secure?',
    answer: 'Yes, your privacy is our priority. All uploaded videos are processed securely and deleted after 7 days.',
    icon: '🔒'
  },
  {
    id: 'target-audience',
    question: 'Who is this service for?',
    answer: 'Anyone who wants to spread holiday cheer with a unique and magical Santa message—perfect for families, friends, and businesses!',
    icon: '👨‍👩‍👧‍👦'
  }
];